import { Sparkles, MessageCircle, Phone } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { BANK_INFO } from "@/data/services";
import { useSiteContent } from "@/hooks/useSiteContent";

// TikTok icon (lucide-react does not include one)
const TikTokIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.55a8.16 8.16 0 0 0 4.77 1.52V6.69h-1.84z" />
  </svg>
);

export const Footer = () => {
  const { t, lang } = useLanguage();
  const { get } = useSiteContent();
  return (
    <footer
      id="contacto"
      className="relative border-t border-white/10 pt-16 pb-8 px-6 lg:px-12"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Sparkles className="w-5 h-5 text-[#d4af37]" />
            <span className="font-serif text-xl gold-text">CrisAngel Astral</span>
          </div>
          <p className="text-sm text-neutral-400 leading-relaxed mb-4">
            {lang === "es"
              ? "Servicios espirituales auténticos: lecturas, hechicería y pactos personalizados."
              : "Authentic spiritual services: readings, witchcraft and personalized pacts."}
          </p>
          <a
            data-testid="footer-tiktok"
            href={BANK_INFO.tiktok}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-sm text-neutral-300 hover:text-[#d4af37] transition-colors border border-white/10 hover:border-[#d4af37]/50 rounded-full px-3 py-1.5"
          >
            <TikTokIcon className="w-4 h-4" />
            TikTok {BANK_INFO.tiktokHandle}
          </a>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">
            {t("nav.contact")}
          </h4>
          <div className="space-y-3">
            <a
              data-testid="footer-whatsapp"
              href={BANK_INFO.whatsappLink}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-sm text-neutral-300 hover:text-[#d4af37]"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp {BANK_INFO.whatsapp}
            </a>
            <a
              data-testid="footer-call"
              href={`tel:${BANK_INFO.whatsapp.replace(/\s+/g, "")}`}
              className="flex items-center gap-2 text-sm text-neutral-300 hover:text-[#d4af37]"
            >
              <Phone className="w-4 h-4" />
              {lang === "es" ? "Llamadas" : "Phone"}: {BANK_INFO.whatsapp}
            </a>
            <a
              data-testid="footer-tiktok-2"
              href={BANK_INFO.tiktok}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-2 text-sm text-neutral-300 hover:text-[#d4af37]"
            >
              <TikTokIcon className="w-4 h-4" /> TikTok {BANK_INFO.tiktokHandle}
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-[0.3em] text-[#d4af37] mb-4">
            {lang === "es" ? "Aviso" : "Notice"}
          </h4>
          <p className="text-xs text-neutral-500 leading-relaxed italic" data-testid="footer-tagline">
            {get("footer.tagline", t("footer.disclaimer"))}
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-white/5 text-center text-xs text-neutral-500">
        © {new Date().getFullYear()} CrisAngel Astral — {t("footer.rights")}
      </div>
    </footer>
  );
};
